import colours from '../ds/styles/sass/variables/colours.variables.scss';
import { dateFormater } from './utils';
import Icon from '../ds/icons/svg/ontario-icon-dropdown-arrow.svg';
import IconDownload from '../ds/icons/svg/ontario-icon-download.svg';
import trans from '../translations.json';
import {
  ToolTipClone,
  ToolTipAnomaly,
} from './toolTipClone/toolTipClone';
import { renderToString } from 'react-dom/server';

export const chartColours = { primary: '#F26A36' };

export const labelStyle = {
  fontSize: '12px',
  colors: [colours.black],
};

export const DownloadButton = (lang, chartTitle = '') =>
  `<Button title="${trans.overview.download[lang]}" aria-label="${
    trans.overview.download[lang] +
    ' ' +
    chartTitle.toLowerCase().replace(/(<([^>]+)>)/gi, '')
  }" class="ant-btn cviz-download-btn">${
    trans.overview.download[lang]
  } <img src='${Icon}' /> </Button>  <img  title="${
    trans.overview.download[lang]
  }" class="covid-download-icon" src='${IconDownload}' /> `;

export const dataLabelsSize = '15px';

// Colours
let colourPalette = {
  general: '#96B8E9',
  neutral: '#D5B758',
  active: '#D0908C',
  resolved: '#A5CFA0',
  death: '#999999',
  secondary: '#626262',
  anomaly: '#9A76B9',
  staff: '#263449',
  percent: '#594A17',
};

// Function to call array of colours
export function getColours(colours) {
  let result = colours.map((colourType) => {
    return colourPalette[colourType];
  });
  return result;
}

// Markers that utilize different sets of colours
export const generalMarkers = {
  size: 3,
  colors: [],
  strokeColors: '#fff',
  strokeWidth: 1,
  hover: {
    size: 9,
  },
};

// Check if the colour should be the normal colour or the anomaly colour
export function anomalyColour(
  value,
  dataPointIndex,
  anomalyList,
  colourPalette,
  seriesIndex,
  w,
) {
  if (w.globals.initialSeries.length < 2) {
    if (value < 0 || anomalyList.includes(dataPointIndex)) {
      return colourPalette[colourPalette.length - 1];
    } else {
      return colourPalette[0];
    }
  } else {
    if (anomalyList.includes(dataPointIndex)) {
      return colourPalette[colourPalette.length - 1];
    } else {
      if (seriesIndex === 0) {
        return colourPalette[0];
      } else {
        return colourPalette[1];
      }
    }
  }
}

// custom wrapper for the anomaly tooltip
export function anomalyToolTip(
  series,
  dataPointIndex,
  w,
  anomalyIndex,
  lang,
  title,
  colourPalette,
) {
  let date =
    w.globals.collapsedSeriesIndices.length === 0
      ? w.globals.initialSeries[0].data[dataPointIndex][0]
      : w.globals.collapsedSeriesIndices[0] === 0
      ? series[1][dataPointIndex]
      : series[0][dataPointIndex];
  const tooltipTitle = () => {
    return dateFormater(date);
  };
  let toolTipData;
  let anomalyData = [];
  if (
    anomalyIndex.includes(dataPointIndex) &&
    w.globals.collapsedSeriesIndices[0] !== 1
  ) {
    if (w.globals.collapsedSeriesIndices.length === 0) {
      toolTipData =
        series.length < 2
          ? [
              {
                label: title[0],
                value: series[0][dataPointIndex].toLocaleString(),
                colour: colourPalette[colourPalette.length - 1],
              },
            ]
          : [
              {
                label: title[0],
                value: w.globals.initialSeries[0].data[
                  dataPointIndex
                ][1].toLocaleString(),
                colour: colourPalette[colourPalette.length - 1],
              },
              {
                label: title[1],
                value: w.globals.initialSeries[1].data[
                  dataPointIndex
                ][1].toLocaleString(),
                colour: colourPalette[1],
              },
            ];
    } else if (w.globals.collapsedSeriesIndices.length === 1) {
      if (w.globals.collapsedSeriesIndices[0] === 0) {
        toolTipData = [
          {
            label: title[1],
            value: w.globals.initialSeries[1].data[
              dataPointIndex
            ][1].toLocaleString(),
            colour: colourPalette[1],
          },
        ];
      } else if (w.globals.collapsedSeriesIndices[0] === 1) {
        toolTipData = [
          {
            label: title[0],
            value: w.globals.initialSeries[0].data[
              dataPointIndex
            ][1].toLocaleString(),
            colour: colourPalette[colourPalette.length - 1],
          },
        ];
      }
    } else {
      toolTipData =
        series.length < 2
          ? [
              {
                label: title[0],
                value: series[0][dataPointIndex].toLocaleString(),
                colour: colourPalette[0],
              },
            ]
          : [
              {
                label: title[0],
                value: w.globals.initialSeries[0].data[
                  dataPointIndex
                ][1].toLocaleString(),
                colour: colourPalette[0],
              },
              {
                label: title[1],
                value: w.globals.initialSeries[1].data[
                  dataPointIndex
                ][1].toLocaleString(),
                colour: colourPalette[1],
              },
            ];
    }

    anomalyData = [
      {
        label: trans.anomalies.tooltip[lang],
      },
    ];
    return renderToString(
      ToolTipAnomaly(tooltipTitle(), toolTipData, anomalyData),
    );
  } else {
    if (w.globals.collapsedSeriesIndices.length === 0) {
      toolTipData =
        series.length < 2
          ? [
              {
                label: title[0],
                value: series[0][dataPointIndex].toLocaleString(),
                colour: colourPalette[0],
              },
            ]
          : [
              {
                label: title[0],
                value: w.globals.initialSeries[0].data[
                  dataPointIndex
                ][1].toLocaleString(),
                colour: colourPalette[0],
              },
              {
                label: title[1],
                value: w.globals.initialSeries[1].data[
                  dataPointIndex
                ][1].toLocaleString(),
                colour: colourPalette[1],
              },
            ];
    } else if (w.globals.collapsedSeriesIndices.length === 1) {
      if (w.globals.collapsedSeriesIndices[0] === 0) {
        toolTipData = [
          {
            label: title[1],
            value: w.globals.initialSeries[1].data[
              dataPointIndex
            ][1].toLocaleString(),
            colour: colourPalette[1],
          },
        ];
      } else if (w.globals.collapsedSeriesIndices[0] === 1) {
        toolTipData = [
          {
            label: title[0],
            value: w.globals.initialSeries[0].data[
              dataPointIndex
            ][1].toLocaleString(),
            colour: colourPalette[0],
          },
        ];
      }
    } else {
      toolTipData = [];
    }
    return renderToString(ToolTipClone(tooltipTitle(), toolTipData));
  }
}

export const tooltip = {
  followCursor: true,
  style: { ...labelStyle },
  x: {
    format: 'MMMM dd',
  },
};

export const stroke = {
  width: 2,
  curve: 'straight',
  //dashArray: [0, 8, 0, 15],
};

export const markers = {
  size: 0,
  strokeColors: '#fff',
  strokeWidth: 1,
  hover: {
    size: 7,
  },
};

export const legend = {
  fontSize: dataLabelsSize,
  position: 'top',
  horizontalAlign: 'left',
  onItemClick: {
    toggleDataSeries: true,
  },
  onItemHover: {
    highlightDataSeries: true,
  },
};

export const skipLabelsFormater = function (value, timestamp, index) {
  //console.log('object', value, index)

  if (index % 2 || index === undefined) {
    return value;
  } else {
    return '';
  }
};

export const lgXaxisLabels = {
  rotateAlways: true,
  rotate: -45,
  offsetY: 5,
  style: { ...labelStyle },
  formatter: skipLabelsFormater,
};

export const lineXaxis = (show = true) => {
  return {
    type: 'datetime',
    labels: {
      show,
      hideOverlappingLabels: true,
      formatter: dateFormater,
      rotateAlways: true,
      rotate: -45,
      offsetY: 5,
      style: { ...labelStyle },
    },
    tooltip: {
      enabled: false,
    },
  };
};

export const responsiveFun = () => [
  {
    breakpoint: 640,
    options: {
      chart: {
        animations: {
          enabled: false,
          animateGradually: {
            enabled: false,
          },
          dynamicAnimation: {
            enabled: false,
          },
        },
        offsetX: 10,
        height: '200px',
        //width: "100%",
        toolbar: {
          tools: {
            zoomin: false,
            zoomout: false,
          },
        },
      },
      yaxis: {
        title: { text: null },
        labels: {
          style: { ...labelStyle, fontSize: '10px' },
          formatter: (value) =>
            value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        },
      },
      xaxis: {
        // max: 10,
        // min: 10,
        // tickAmount: 5,
        // axisTicks: {
        //   show: true,
        //   borderType: 'solid',
        //   color: '#78909C',
        //   height: 6,
        //   offsetX: 0,
        //   offsetY: 0
        // },
        labels: {
          hideOverlappingLabels: true,
          offsetY: 5,
          rotateAlways: true,
          rotate: -45,
          formatter: skipLabelsFormater,
          style: { ...labelStyle, fontSize: '12px' },
        },
      },
      legend: {
        fontSize: '10px',
      },
      dataLabels: {
        enabled: false,
      },
    },
  },
  {
    breakpoint: 1163,
    options: {
      chart: {
        animations: {
          enabled: false,
          animateGradually: {
            enabled: false,
          },
          dynamicAnimation: {
            enabled: false,
          },
        },
        height: '250px',
        width: '100%',
      },
      legend: {
        fontSize: '12px',
      },
      yaxis: {
        title: { text: null },
        labels: {
          style: { ...labelStyle, fontSize: '10px' },
          formatter: (value) =>
            value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        },
      },
      xaxis: {
        // max: 30,
        labels: {
          hideOverlappingLabels: true,
          offsetY: 5,
          rotateAlways: true,
          rotate: -45,
          style: { ...labelStyle },
        },
      },
      dataLabels: {
        style: { ...labelStyle, fontSize: '10px' },
        orientation: 'horizontal',
      },
    },
  },
  {
    breakpoint: 1530,
    options: {
      chart: {
        animations: {
          enabled: false,
          animateGradually: {
            enabled: false,
          },
          dynamicAnimation: {
            enabled: false,
          },
        },
        height: '250px',
        width: '100%',
      },
      legend: {
        fontSize: '12px',
      },
      yaxis: {
        title: { text: null },
        labels: {
          style: { ...labelStyle, fontSize: '10px' },
          formatter: (value) =>
            value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
        },
      },
      xaxis: {
        labels: {
          offsetY: 5,
          hideOverlappingLabels: true,
          rotateAlways: true,
          rotate: -45,
          style: { ...labelStyle },
        },
        dataLabels: {
          offsetX: 10,
          style: { ...labelStyle, fontSize: '12px' },
          orientation: 'horizontal',
        },
      },
    },
  },
];
